import { AssessmentType } from '../enums/shared.enums';
/**
 * Type guard to check if a given value is a valid AssessmentType.
 */
export function isValidAssessmentType(assessment: unknown): assessment is AssessmentType {
  return Object.values(AssessmentType).includes(assessment as AssessmentType);
}

/**
 * Filters an array of potential assessments and returns only valid AssessmentType values.
 * @param assessments - An array of items that might be AssessmentTypes.
 * @returns An array of valid AssessmentType.
 */
export function filterValidAssessmentTypes(
  assessments?: (AssessmentType | string | unknown)[]
): AssessmentType[] {
  if (!assessments) {
    return [];
  }
  return assessments.filter(isValidAssessmentType);
}
